const translations = {
    noAssets: 'No assets are available to configure.'
};

export default translations;
